import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import { ThemeProvider } from './contexts/ThemeContext.tsx';
import './index.css';

console.log(`[sop-ai] version ${__APP_VERSION__}`);

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: __APP_VERSION__,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    initialScope: (scope) => {
      if (import.meta.env.VITE_SENTRY_ORG) {
        scope.setTag('sentry_org', import.meta.env.VITE_SENTRY_ORG);
      }
      if (import.meta.env.VITE_SENTRY_PROJECT) {
        scope.setTag('sentry_project', import.meta.env.VITE_SENTRY_PROJECT);
      }
      return scope;
    },
  });
}

if (import.meta.env.VITE_SENTRY_EXPOSE === 'true') {
  window.Sentry = Sentry;
  console.log('[sop-ai] Sentry exposed on window.Sentry');
}

(() => {
  try {
    const v = localStorage.getItem('soperator-theme');
    const pref = v === 'light' || v === 'dark' || v === 'system' ? v : 'system';
    const dark =
      pref === 'dark' ||
      (pref === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    document.documentElement.classList.toggle('dark', dark);
  } catch {
    /* ignore */
  }
})();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);
